import { useEffect } from 'react';
import useAuth from 'hooks/useAuth';
import { Helmet } from 'react-helmet-async';

function getCurrentTenant() {
  const hostname = window.location.hostname;
  // localhost or direct IP → default tenant
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost')) {
    return 'chisel';
  }
  const parts = hostname.split('.');
  // invalid or unexpected hostname
  if (parts.length < 3) {
    return 'chisel';
  }
  const tenant = parts[0];
  return tenant || 'chisel';
}

const TenantBranding = ({ children }) => {
  const { getTenantLogoAction, tenantLogo } = useAuth();

  const tenant = getCurrentTenant();

  useEffect(() => {
    const realTenant = tenant === 'aqm' ? 'chisel' : tenant;
    getTenantLogoAction({ tenant: realTenant });
  }, [tenant]);
  return (
    <>
      <Helmet>
        <title>{tenant.toUpperCase()}</title>
        <link rel="icon" href={tenantLogo} />
      </Helmet>

      {children}
    </>
  );
};

export default TenantBranding;
